import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { DialogHelper } from "../../core/util/dialogHelper";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { AppHelper } from "../../appHelper";
import { AppBaseProps, CommonApp, Entity } from "../../core/components/commonApp";
import { Helper } from "../../core/util/helper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { ContextGeneralSettingsApp } from "../generalSettings";
import { BaseField } from "../../core/components/baseComponentProps";
import React from "react";
export default class TicketStatusGrid extends React.Component<TicketStatusGridProps, { gridData: TicketStatus[] }> {
    private metaData: any;
    constructor(props) {
        super(props);
        this.state = { gridData: [] };
        this.initApp();
    }

    private initApp = () => {
        this.metaData = {
            additional: {
                objects: []
            },
            tabs: [
                {
                    iconName: "square-exclamation",
                    title: Helper.getTranslation("Server.Allgemein"),
                    regions: [
                        {
                            title: Helper.getTranslation("Server.Allgemein"),
                            visible: true,
                            fields: [
                                {
                                    model: "entity.StatusId",
                                    name: Helper.getTranslation("Standard.Key"),
                                    readOnly: "!entity.IsNew",
                                    visible: true,
                                    type: "is-numeric-text-box",
                                    format: "0",
                                    decimals: 0,
                                    required: true
                                }
                            ]
                        },
                        {
                            title: Helper.getTranslation("BrowserTitle.Translations"),
                            visible: true,
                            fields: [
                                {
                                    columnName: Helper.getTranslation("Standard.Bezeichnung"),
                                    labelAndControlCombined: true,
                                    maxLenght: 60,
                                    model: "entity.Translations",
                                    moduleName: "app/editIndividualFields/editTranslations",
                                    name: "Translations",
                                    readOnly: false,
                                    type: "dynamic",
                                    visible: true
                                }

                            ]
                        }

                    ]
                }
            ],
            rightDrawerContainer: {
                visible: true,
                width: 400,
                multipleComponents: [
                    {
                        moduleName: "app/core/components/iframe",
                        iconName: "question-circle",
                        renderAlways: true,
                        props: {
                            url: "{{helpBaseUrl}}/{{helpVersion}}/{{helpLanguage}}/8faa19c5-5442-487e-bda4-e65f9411c3c6.html"
                        },
                        type: "rightdrawer_help",
                    }
                ]
            },
            menuDataSource: [
                {
                    type: "save"
                },
                {
                    type: "delete",
                    onClick: "deleteStatus()",
                    show: "!entity.IsNew"
                }
            ]
        };
        if (this.props.entity.TicketSettings.VorgangsstatusRechte) {
            this.metaData.tabs.push({
                title: Helper.getTranslation("Dokument.Permission.Permission"),
                iconName: "low-vision",
                regions: [
                    {
                        title: Helper.getTranslation("Dokument.Permission.UserPermission"),
                        visible: true,
                        size: [
                            {
                                container: "extrasmall",
                                width: "12/12"
                            },
                            {
                                container: "small",
                                width: "12/12"
                            },
                            {
                                container: "medium",
                                width: "6/12"
                            },
                            {
                                container: "large",
                                width: "6/12"
                            },
                            {
                                container: "extralarge",
                                width: "6/12"
                            }
                        ],
                        fields: [
                            {
                                visible: true,
                                type: "dynamic",
                                model: "entity.UserPermissions",
                                labelAndControlCombined: true,
                                moduleName: "app/generalSettings/documents/editDokuKatPermission",
                                dataSourceUrl: "DocumentsSettings/GetUsers",
                                label: Helper.getTranslation("Server.User"),
                                replacementLabel: Helper.getTranslation("Dokument.Permission.NoUserPermissions")
                            }
                        ]
                    }, {
                        title: Helper.getTranslation("WebSMS.UserSettings.GroupRight"),
                        visible: true,
                        size: [
                            {
                                container: "extrasmall",
                                width: "12/12"
                            },
                            {
                                container: "small",
                                width: "12/12"
                            },
                            {
                                container: "medium",
                                width: "6/12"
                            },
                            {
                                container: "large",
                                width: "6/12"
                            },
                            {
                                container: "extralarge",
                                width: "6/12"
                            }
                        ],
                        fields: [
                            {
                                visible: true,
                                type: "dynamic",
                                model: "entity.GroupPermissions",
                                labelAndControlCombined: true,
                                moduleName: "app/generalSettings/documents/editDokuKatPermission",
                                dataSourceUrl: "DocumentsSettings/GetGroups",
                                label: Helper.getTranslation("WebCRM.Administration.Gruppe"),
                                replacementLabel: Helper.getTranslation("Dokument.Permission.NoGroupPermission")
                            }
                        ]
                    }, {
                        title: Helper.getTranslation("WebSMS.UserSettings.MaingroupRights"),
                        visible: true,
                        size: [
                            {
                                container: "extrasmall",
                                width: "12/12"
                            },
                            {
                                container: "small",
                                width: "12/12"
                            },
                            {
                                container: "medium",
                                width: "6/12"
                            },
                            {
                                container: "large",
                                width: "6/12"
                            },
                            {
                                container: "extralarge",
                                width: "6/12"
                            }
                        ],
                        fields: [
                            {
                                visible: true,
                                type: "dynamic",
                                model: "entity.MainGroupPermissions",
                                labelAndControlCombined: true,
                                moduleName: "app/generalSettings/documents/editDokuKatPermission",
                                dataSourceUrl: "DocumentsSettings/GetMainGroups",
                                label: Helper.getTranslation("WebSMS.ActionLook.MainGroup"),
                                replacementLabel: Helper.getTranslation("Dokument.Permission.NoMainGroupDefined")
                            }
                        ]
                    }
                ]
            });
        }
        this.loadGridData();
    }

    private loadGridData = async () => {
        const result = await HTTPService.get<JsonResultClass<TicketStatus[]>>("GeneralSettings/GetTicketStatus");
        this.setState({ gridData: result.Data })
    }

    private handleClickStandardButton = async (type: ToolBarStandardButtonType, dataItem: TicketStatus) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                const id = Math.max(...this.state.gridData.map((item) => parseInt(item.Prostatuskey))) + 1;
                this.openSheet({
                    IsNew: true,
                    IsWatchable: false,
                    IsWatched: false,
                    RecordRight: { CanRead: true, CanWrite: true },
                    IndividualFields: {},
                    Translations: [],
                    StatusId: id,
                    GroupPermissions: [],
                    MainGroupPermissions: [],
                    UserPermissions: []
                })
                break;
            case ToolBarStandardButtonType.EDIT:
                const result = await HTTPService.get<JsonResultClass<TicketStatusViewModel>>(`GeneralSettings/GetTicketStatusById?id=${dataItem.Prostatuskey}`)
                if (result.Code == 0) {
                    this.openSheet(result.Data)
                }
                break;
            case ToolBarStandardButtonType.DELETE:
                await this.delete(parseInt(dataItem.Prostatuskey))
                break;
        }        
    }

    private delete = async (id: number) => {
        const isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOk) {
            const result = await HTTPService.get<JsonResultClass>(`GeneralSettings/DeleteTicketStatus?id=${id}`);
            if (result.Code == 1) {
                NotificationHelper.showErrorMessage(Helper.getTranslation(result.Message));
            } else {
                await this.loadGridData();
            }
            return result.Code == 0;
        }
        return isOk;
    }

    private openSheet = (status: TicketStatusViewModel) => {
        const props: EditTicketStatusProps = {
            context: {

            },
            dataSources: {},
            entity: status,
            isWindow: false,
            metadata: this.metaData,
            title: "",
            delete: this.delete
        } 
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, this.loadGridData);
        //sheet.setTitle(Helper.getTranslation("WebSMS.GeneralSettings.Tickets.Tickettypen"));
        sheet.show(() => {
            sheet.mountContent(EditTicketStatus, props);
        });

    }


    render() {

        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: !this.props.disabled },
            { type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: !this.props.disabled },
            { type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: !this.props.disabled }
        ];
        

        return (
            <div style={{ height: "100%", width: "100%" }}>
                <div className="flex-container flex-container__item" style={this.props.field.style}>
                    <Grid data={this.state.gridData} options={this.props.context.editTicketStatusGridOptions} id="editTicketStatusGrid"
                        standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} />
                </div>
            </div>
        );
    }
};

interface TicketStatusGridProps {
    field: EditTicketStatusField;
    context: ContextGeneralSettingsApp;
    disabled: boolean;
    entity: any;
}

interface TicketStatus {
    Prostatuskey: string;
    Beschreibung: string;
}

interface EditTicketStatusField extends BaseField {
    style: React.CSSProperties
}

class EditTicketStatus extends React.Component<EditTicketStatusProps, any>{
    common = new AppHelper();
    constructor(props) {
        super(props)
        this.common.enableHooks = false;
        this.common.init(this);


    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = async () => {
        const result = await HTTPService.post<JsonResultClass>("GeneralSettings/SaveTicketStatus", {
            status: this.props.entity
        });
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"));
            this.props.entity.IsNew = false;
        } else {
            NotificationHelper.showErrorMessage(result.Message)
        }
        this.common.handlePostSave(result.Code === 0, false);
        this.setState({});
    }

    deleteStatus = async () => {
        const success = await this.props.delete(this.props.entity.StatusId);
        if (success) {
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Ressource.LöschenErfolgreich"));
            this.common.sheetWrapper.hide();
        }
    }

    componentDidMount() {
        this.common.updateSheetTitle(Helper.getTranslation("WebSMS.GeneralSettings.Tickets.EditTicketStatus"))
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface TicketStatusViewModel extends Entity{
    StatusId: number;
    Translations: [];

    UserPermissions: [];
    GroupPermissions: [];
    MainGroupPermissions: [];
}

interface EditTicketStatusProps extends AppBaseProps {
    entity: TicketStatusViewModel;
    delete: (id: number) => Promise<boolean>;
}
